import { httpRequest } from "../../http";
import type { Ad } from "@models/Ad.model";

export interface AdMediaResult {
    ad_id: number;
    /** The ad's display leaf, its content limited to the media and preview (null for any type
     *  but image and video); null when the ad is outside the selected organizations. */
    ad: Ad | null;
}

/**
 * Media for the Partner Dashboard's Ads carousel, in one call (MPN-2341). The cards cannot
 * fetch their own from /content/ads/resolve/: that endpoint is scoped to the content catalog,
 * which a client user may not see, so it answers 403.
 */
export class CommandGetAdMedia {
    async run(organizationIds: number[], adIds: number[]): Promise<AdMediaResult[]> {
        // GET, not POST: client roles hold Dashboard at VIEW only, and POST requires CREATE.
        const params = new URLSearchParams();
        for (const id of organizationIds) params.append("org_ids", String(id));
        for (const id of adIds) params.append("ad_ids", String(id));

        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/ad-media/?${params.toString()}`;
        try {
            const response = await httpRequest<{ results: AdMediaResult[] }>(url);
            return response?.results ?? [];
        } catch (error) {
            console.error("Error fetching ad media:", error);
            throw error;
        }
    }
}
